import { render, staticRenderFns } from "./AppSelfieCamera.vue?vue&type=template&id=2a098e69"
import script from "./AppSelfieCamera.vue?vue&type=script&lang=js"
export * from "./AppSelfieCamera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports